export default __webpack_public_path__ + "static/media/wood-measurements-2.42cd9037.jpg";